import { createSelector } from 'reselect'

import { selectFinSobSidePanelData } from './selectFinSobSidePanelData'

export const selectDisabledFinSobCategories = createSelector([selectFinSobSidePanelData], (data) =>
  data
    .filter(({ IsApplicable, IsTotalCategory }) => !IsApplicable && !IsTotalCategory)
    .map(({ Title }) => Title)
)
